/* eslint-disable max-len */
import React from 'react';

function ArrowForwordIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_7433_4636)">
                <path
                    d="M5.50618 -1.18034e-07C5.27578 -7.77494e-08 5.04538 0.0880001 4.86978 0.2636C4.51818 0.6152 4.51818 1.1848 4.86978 1.5364L11.3338 8L4.86978 14.4636C4.51818 14.8148 4.51818 15.3848 4.86978 15.7364C5.22098 16.088 5.79138 16.088 6.14258 15.7364L12.9178 8.9608C13.2018 8.6768 13.3526 8.2948 13.3314 7.9132C13.3126 7.5688 13.1534 7.244 12.8926 7.0136L6.14258 0.2636C5.96698 0.088 5.73658 -1.58318e-07 5.50618 -1.18034e-07Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_7433_4636">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="matrix(1 0 0 -1 0 16)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default ArrowForwordIcon;
